import { forwardRef, useMemo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

//* Component
import Text from 'components/common/Text';

//* Style
import RunningTextStyle from './style';

const RunningText = forwardRef(({ className, text, arr }, ref) => {
	//! Ref
	const textRef = useRef();

	//! Store
	const tl = useMemo(() => new gsap.timeline({ repeat: -1, paused: true }), []);

	useEffect(() => {
		tl.progress(0).clear();

		tl.to(textRef.current, 14, {
			x: '-50%',
			ease: 'none',
		});

		tl.play();
	}, []);

	//! Text HTML
	const storeText = useMemo(() => {
		return text ? (
			<div className={`flex-align-wrapper`}>
				<Text
					className={`h2 no-wrap uppercase minion3-medium primary-color9`}
					text={text}
				/>
			</div>
		) : (
			arr &&
				arr.length > 0 &&
				arr.map((item, index) => (
					<div
						key={index}
						className={`arr-flex-align-wrapper`}>
						<Text
							tag={`p`}
							className={`no-wrap uppercase p p1 notoSans-medium primary-color9`}
							text={item}
						/>
					</div>
				))
		);
	}, [text, arr]);

	return (
		<RunningTextStyle
			ref={ref}
			className={`running-text ${className || ''}`}>
			<div className={`overflow-hidden`}>
				<div
					ref={textRef}
					className={`relative scrolling-wrap`}>
					{storeText}

					{storeText}

					<div className={`duplicate-wrap`}>
						{storeText}

						{storeText}
					</div>
				</div>
			</div>
		</RunningTextStyle>
	);
});

export default RunningText;
